<template>
  <div class="mb-6">
    <div>
      <span v-if="_event.private" class="absolute bg-blue-gradient uppercase m-4 px-2 py-1 text-base rounded">
        Private Event
      </span>
      <router-link class="no-underline" :to="{ name: 'events-basics', params: { id: this._event.id } }">
        <img
          style="height: 218px; object-fit: cover;"
          class="rounded-lg shadow-lg"
          :alt="_event.title"
          :src="_event.image ? _event.image + '?auto=format&fit=crop&h=619&w=1024' : '/img/hems-event-holder.png'"
        />
      </router-link>
    </div>
    <div class="pt-2" :class="statusClasses">
      {{statusText}}
    </div>

    <div class="event-spacer" />

    <h3 class="text-2xl font-sans text-n-gray-dark font-hairline">
      <router-link class="no-underline" :to="{ name: 'events-basics', params: { id: this._event.id } }">
        {{_event.title}}
      </router-link>
    </h3>

    <div class="event-spacer" />

    <div class="text-base" v-html="_event.teaser" />

    <div class="event-spacer" />

    <div class="uppercase">
      <div class="text-base font-sans-bold">
        {{ _event.start_at | moment('ddd. MMMM DD') }}
      </div>
      <div class="text-2xl leading-tight font-sans-bold" v-if="_event.venue">
        <template v-if="_event.type === 'physical' || _event.venue.url">@</template>
      </div>
    </div>

    <div class="text-base" v-if="_event.venue">
      <div v-if="_event.venue.url && _event.type !== 'physical'">
        <a target="_blank" :href="_event.venue.url">
          {{ _event.venue.name }}
        </a>
        <br />
      </div>
      <div v-else>
        {{ _event.venue.name }}
      </div>
      <template v-if="_event.type === 'physical'">{{ _event.venue.address_1 }}</template>
      <br>
      <span v-if="_event.venue.city">
        {{ _event.venue.city }}, {{ _event.venue.state }} {{ _event.venue.zip }}
      </span>
    </div>

    <div class="text-base" v-if="_event.start_at && _event.end_at">
      {{ _event.start_at | moment('h:mm') }} - {{ _event.end_at | moment('h:mm A') }} PDT
    </div>
  </div>
</template>

<script>
export default {
  name: "EventCard",
  props: {
    _event: { type: Object, required: true }
  },
  computed: {
    statusText() {
      if (this._event.published) {
        return 'Published'
      }

      return this._event.status === 'new' ? 'Draft' : 'In Review';
    },
    statusClasses() {
      if (!this._event.published && this._event.status === 'new') {
        return 'uppercase text-base text-red';
      }

      return 'uppercase text-base text-gray-darker';
    }
  },
}
</script>

<style scoped>
.event-spacer {
  @apply mb-3;
}
</style>